import { MainLoader } from "@/components/loader/MainLoader"
import { useAuthContext } from "@/context-state/AuthContext"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import * as API from "@/services/api"
import { toast } from "sonner"

export const SpaceMembersDataProvider = ({ children }) => {
    const { setSpaceUsers, getSpaceUsers } = useAuthContext()

    const { spaceId } = useParams()

    const spaceUsers = getSpaceUsers(spaceId)

    const fetchSpaceUsers = async () => {
        try {
            const { data } = await API.getSpaceUsers(spaceId)
            setSpaceUsers(spaceId, data)
        } catch (e) {
            console.error(e)
            toast.error('Failed to fetch space users')
        }
    }

    useEffect(() => {
        if (!spaceUsers.length) {
            fetchSpaceUsers()
        }
    }, [spaceId])

    return spaceUsers?.length ? children : <MainLoader className="bg-hero-background bg-cover bg-center bg-no-repeat" />
}